// src/Components/Assets/AssetGrid.js

import React from 'react';
import AssetCard from './AssetCard';

const AssetGrid = ({ assets, onSelect, selectedAssets, onPreview }) => {
  if (!assets || assets.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-64 bg-white rounded-lg shadow-sm border text-gray-500">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mb-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <p className="text-lg font-medium">Your Media Library is Empty</p>
        <p className="text-sm">Click the "Upload" button to add your first asset.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
      {assets
        .filter(asset => !!asset) 
        .map((asset) => (
        <div key={asset.url} className="relative group">
          {/* --- THIS IS THE FIX: Checkbox is now always visible --- */}
          <div 
            className="absolute top-2 left-2 z-30" 
            onClick={(e) => e.stopPropagation()} 
          >
            <input
              type="checkbox"
              className="h-5 w-5 cursor-pointer accent-brand-primary border-gray-300 rounded focus:ring-brand-primary"
              checked={selectedAssets.includes(asset.url)}
              onChange={() => onSelect(asset.url)}
            />
          </div>
          {/* --- END OF FIX --- */}
          <AssetCard 
            asset={asset} 
            onPreview={onPreview} 
          />
        </div>
      ))}
    </div>
  );
};

export default AssetGrid;